import { DisplayFieldProps } from '../../../../interfaces/interfaceReassignment';
import { BasicSelectComponent } from '../../../../components/BasicSelectComponentComponent';
import { IReassigmentProvider } from '../../../../interfaces/service/ReassignmentServiceManagerInterface';
import { Button } from 'primereact/button';

interface IDeviceForm {
  serviceReassignment: IReassigmentProvider;
}

export const DeviceForm = ({ serviceReassignment }: IDeviceForm) => {
  const DisplayField = ({
    label,
    field,
    value,
    truncate,
  }: DisplayFieldProps) => {
    console.log('value', value);
    const fieldValue = value[field];

    return (
      <div className="flex flex-col w-full mx-5 my-2">
        <label className="font-bold text-grey">{label}</label>
        <span
          className={`truncate max-w-full ms-3 ${fieldValue ? '' : 'italic'}`}
          title={fieldValue?.toString() ?? ''}>
          {fieldValue ? truncate(fieldValue.toString()) : '**No disponible'}
        </span>
      </div>
    );
  };

  const renderReasonInput = () => (
    <div className="flex flex-col w-full mx-5 my-2">
      <label htmlFor="reasonInput" className="font-bold text-grey">
        Comentario de Reasignación
      </label>
      <textarea
        id="reasonInput"
        className="border border-grey rounded-md p-2 mt-2 w-[90%] resize-none"
        placeholder="Comenta la razón de reasignación"
        name="reason"
        rows={3}
        onChange={serviceReassignment.handleReasonChange}
      />
    </div>
  );

  const samIdSelect = () => (
    <div className="flex flex-col w-full mx-5">
      <span className="font-bold text-grey mt-2">Sam ID</span>
      <BasicSelectComponent
        name="SamName"
        optionLabel="SamName"
        optionValue="SamId"
        options={serviceReassignment.selectSamData.sams}
        classNames="w-[90%]"
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          serviceReassignment.onSamIdSelection(Number(e.target.value))
        }
      />
    </div>
  );
  return (
    <div className="flex flex-col h-full w-full">
      <DisplayField
        label="Tipo Equipo"
        field="DeviceTypeName"
        value={serviceReassignment.dataRow}
        truncate={serviceReassignment.truncateText}
      />
      {serviceReassignment.deviceFormInfo.map(item => (
        <DisplayField
          key={item.key}
          label={item.label}
          field={item.key}
          value={serviceReassignment.dataRow}
          truncate={serviceReassignment.truncateText}
        />
      ))}

      <DisplayField
        label="Id lector"
        field="DeviceNumber"
        value={serviceReassignment.dataRow}
        truncate={serviceReassignment.truncateText}
      />

      <div className="flex flex-col w-full mx-5 my-2">
        <span className="font-bold text-grey">Tipo de SAM</span>
        <BasicSelectComponent
          name="TE"
          optionLabel="SamTypeName"
          optionValue="SamTypeId"
          options={serviceReassignment.selectSamData.samTypes}
          classNames="w-[90%]"
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            serviceReassignment.onFormSamTypeChange(Number(event.target.value))
          }
        />
      </div>

      {serviceReassignment.selectSamData.sams.length > 0 && (
        <>
          {samIdSelect()}
          {renderReasonInput()}
        </>
      )}

      <div className="flex w-full items-end justify-center mt-auto">
        <div className="mx-1">
          <Button onClick={serviceReassignment.closeRightMenu}>Cancelar</Button>
        </div>
        <div className="mx-1">
          <Button onClick={serviceReassignment.onSubmit}>Reasignar</Button>
        </div>
      </div>
    </div>
  );
};
